import { useTranslation } from "react-i18next"
import { IPatientSurvey } from "../../types/types"

interface ISurveyListCard {
  patientSurvey: IPatientSurvey
  openSurvey: () => void
}

const SurveyListCard = (props: ISurveyListCard) => {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col w-80 md:w-96 rounded-xl px-4 py-4 bg-cortexx-50 border-slate-300 border">
      <div className="font-bold text-cortexx-550">
        {t(`surveys.${props.patientSurvey.survey_reference}`)}
      </div>
      <div className="font-normal text-slate-500">
        {t("surveys.answered_on")}{" "}
        {new Date(props.patientSurvey.submission.created_at).toLocaleDateString(
          "fr"
        )}
      </div>
      <div className="flex justify-end">
        <button className="flex" onClick={() => props.openSurvey()}>
          <div className="bg-cortexx-550 rounded-lg mt-2 text-center justify-center px-8 py-2">
            <div className="text-cortexx-50">{t("surveys.view")}</div>
          </div>
        </button>
      </div>
    </div>
  )
}

export default SurveyListCard
